import React from "react";

import { useBreakpoint } from "../../hooks/useBreakpoint";
import { ConditionalSwiper } from "../shared/conditionalSwiper";
import VideoSocialCard from "../cards/videoSocialCard";
import VideoCard from "../cards/videoCard";

const layouts = Object.freeze({
  std: ""
});

const VideoGrid = ({
  cardOption,
  containerClass,
  gridClass,
  videos,
  conditionalSliderOpts,
  instagramIconColor,
  socialClass,
  socialImageClass,
  extraSocialNameTextClass,
  extraSocialDateTextClass
}) => {
  const breakpoint = useBreakpoint();

  return (
    <div className={containerClass}>
      <div className={`grid ${gridClass} `}>
        <ConditionalSwiper
          condition={breakpoint === "xs"}
          slidesPerView={1.25}
          spaceBetween={10}
          centeredSlides={false}
          className="h-full w-full"
        >
          {videos?.map((displayVid, idx) => {
            return cardOption === "social" ? (
              <VideoSocialCard
                key={`social-vid-${idx}`}
                {...displayVid}
                instagramIconColor={instagramIconColor}
                socialClass={socialClass}
                socialImageClass={socialImageClass}
                extraSocialNameTextClass={
                  extraSocialNameTextClass ||
                  displayVid?.extraSocialNameTextClass
                }
                extraSocialDateTextClass={extraSocialDateTextClass}
              />
            ) : (
              <VideoCard key={`general-vid-${idx}`} {...displayVid} />
            );
          })}
        </ConditionalSwiper>
      </div>
    </div>
  );
};

export default VideoGrid;

VideoGrid.defaultProps = {
  conditionalSliderOpts: {
    condition: true,
    slidesPerView: 1.25,
    spaceBetween: 10,
    centeredSlides: true,
    className: "w-full h-full"
  }
};
